import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollUpdateEmployeeDataGeneralSettingsRequest,
  PayrollUpdateEmployeeDataGeneralSettingsResponse,
} from '../types';

export const updateEmployeeDataGeneralSettingsMutation = gql`
  mutation PayrollUpdateEmployeeDataGeneralSettings($input: PayrollEmployeeDataGeneralSettingsInput!) {
    payrollUpdateEmployeeDataGeneralSettings(input: $input) {
      data {
        updatedSections
        settings {
          employeeIds {
            mode
            employeeIdPrefix
            employeeIdLength
            enableSeparateContractorIdSeries
            contractorIdPrefix
          }
          employeeDirectory {
            enabled
          }
          payslip {
            showEmployeeId
            showBrandName
            showCompanyAddress
          }
          legacyOptionalFields {
            key
            label
            enabled
            customLabel
            type
          }
          limits {
            maxEmployeeIdLength
            maxContractorIdPrefixLength
            maxLegacyCustomFields
          }
        }
      }
      code
      success
      message
    }
  }
`;

export const updateEmployeeDataGeneralSettings = (
  queryVariables: PayrollUpdateEmployeeDataGeneralSettingsRequest,
) =>
  graphQLApi<
    PayrollUpdateEmployeeDataGeneralSettingsResponse,
    PayrollUpdateEmployeeDataGeneralSettingsRequest
  >({
    query: updateEmployeeDataGeneralSettingsMutation,
    queryVariables,
  });
